<!--  -->
<template>
  <div>
      <el-tree :data="nodeItems" show-checkbox
  default-expand-all
  node-key="id" 
  :props="defaultProps"
  @check-change="_nodeItemCheckChangeHandler"></el-tree>


  </div>
</template>

<script>

import {MapService,MapServices} from "../model/MapService.js";
import {ServiceTreeNodeItem,UCMapServiceEvent} from "./UCMapServiceJs.js";

export default {
name:"UCMapServiceTree",
  data () {
    return {

        nodeItems:new Array(),

        defaultProps: {
          children: 'children',
          label: 'name'
        }

    };
  },

  components: {},

  computed: {},

  mounted() {},

  methods: {



      init()
      { 
         let services =  MapServices.mockDatas();
         this.nodeItems =  ServiceTreeNodeItem.createRootNodeItems(services);
      },

      on_nodeItemCheckChange(callback)
      { 
        this.$on(UCMapServiceEvent.UCMapServiceTree_nodeItemCheckChange,callback);
      },  



      _nodeItemCheckChangeHandler(curNodeItem, checked, indeterminate) {
        
        if(curNodeItem.children.length !=0)return;

        curNodeItem.checkedStatus=checked;
        
        // console.log(curNodeItem, checked, indeterminate);
        this.$emit(UCMapServiceEvent.UCMapServiceTree_nodeItemCheckChange,curNodeItem);
      },

  }
}

</script>
<style >
</style>